export default "__VITE_ASSET__w40QpEF2__"